module.exports = __webpack_public_path__ + "Pe-icon-7-stroke.dedf26989fdd78c33cb9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/newtheme/fonts/Pe-icon-7-stroke.svg?d7yf1v
// module id = 485
// module chunks = 2